export default {
  buttons: {
    change_plan: 'Changer de plan',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
  },
};
